import { useHistory } from 'react-router-dom';
import { useAppSelector } from '.';
import { postEvent } from '../core/api';
import { APIEvents } from '../core/constants';
import { useVisitor } from '../context/visitorContext';

export const useSendEvent = (
  block: string,
  type: string = APIEvents.click_cta
) => {
  const { visitorId } = useVisitor();
  const userId = useAppSelector((s) => s.user.user?.AmazonCognitoId);
  const history = useHistory();

  return {
    sendEvent: () => {
      let source = history?.location?.pathname;
      let query_string: string = '';
      if (
        source &&
        (type === APIEvents.click_cta || type === APIEvents.view_cta)
      ) {
        const urlParts = history.location.pathname.split('?');
        source = `customer-app ${urlParts[0]}`;
        query_string = urlParts[1];
      } else {
        source = 'customer-app';
      }

      postEvent(userId || visitorId, {
        type,
        source,
        block,
        query_string,
      }).catch(console.log);
    },
  };
};
